import { useUniversalEntityPageContext } from "../contexts/UniversalEntityPageContext";
import { useFilterContext } from "@/contexts/FilterContext";
import type { BaseEntity } from "../../UniversalCRMTable/types";

/**
 * Safely initializes optional context hooks
 * Handles try-catch for contexts that may not be available in all scenarios
 */
export function useContextHooks<T extends BaseEntity>() {
  // CRITICAL: Compute activeViewId BEFORE any conditional hook calls
  // This ensures stable hook ordering regardless of URL params
  let context;
  try {
    context = useUniversalEntityPageContext<T>();
  } catch {
    context = null;
  }

  const savedViewsState = context?.savedViewsState;

  // Get FilterContext - single source of truth for all filters
  let filterContext;
  try {
    filterContext = useFilterContext<T>();
  } catch {
    filterContext = null;
  }

  return {
    context,
    filterContext,
    savedViewsState,
  };
}
